module.exports = __webpack_public_path__ + "media/images/rupes-nigra-DIN-eeb67e893afb811d8c448e01638d1458.png";